import React from 'react';
import { HeaderIconProps } from './types';

export const AccountIcon: React.FC<HeaderIconProps> = ({
  disabled = false,
}: HeaderIconProps): JSX.Element => {
  const color = disabled ? '#cccccc' : '#ffffff';
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 12.1075C1 10.1922 2.5526 8.63965 4.46782 8.63965H8.93565C10.8509 8.63965 12.4035 10.1922 12.4035 12.1075C12.4035 12.5422 12.0511 12.8946 11.6163 12.8946H1.78713C1.35241 12.8946 1 12.5422 1 12.1075Z"
        stroke={color}
        strokeWidth="2"
      />
      <circle
        cx="6.70181"
        cy="3.6188"
        r="2.6188"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};
